import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { Globals } from '@core/globals';
import { GlobalAnimations } from '@core/animations';
import { MenuItems } from '@core/menu';
import { ButtonComponent } from '@atoms/button/button.component';
import { IconComponent } from '@atoms/icon/icon.component';
import { UnderlineLinkComponent } from '@atoms/underline-link/underline-link.component';
import { ModalDirective } from '@directives/modal.directive';
import { PhonePipe } from '@pipes/phone.pipe';
import { LayoutService } from '@services/layout.service';
import { LinkPipe } from '@pipes/link.pipe';
import { NavigationService } from '@services/navigation.service';

@Component({
  selector: 'app-header',
  imports: [RouterModule, TranslateModule, ButtonComponent, IconComponent, UnderlineLinkComponent, ModalDirective, PhonePipe, LinkPipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [GlobalAnimations.opacity],
})
export class HeaderComponent {
  public globals = inject(Globals);
  private layoutService = inject(LayoutService);
  public navigationService = inject(NavigationService);
  @Input() type: 'default' | 'list' = 'default';
  public menuItems = MenuItems;
  public mobileMenuOpen: boolean = false;

  toggleMobileMenu(status: boolean): void {
    this.mobileMenuOpen = status ?? !this.mobileMenuOpen;
    if (this.mobileMenuOpen) this.layoutService.disableScroll('header');
    else this.layoutService.enableScroll('header');
  }
}
